import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import useCountdown from 'hooks/useCountdown';
import { useSelector } from 'hooks/useSelector';
import { setAuthStep } from 'modules/auth/actions';
import { LOGIN_STEPS } from 'modules/auth/constant';
import { getUnlockedAt as getUnlockedAtSelector } from 'modules/auth/selectors';
import { Alert } from 'ui/base';

const AccountLockWrapper = () => {
  const dispatch = useDispatch();
  const unlockedAt = useSelector(getUnlockedAtSelector);
  const { countdown: seconds } = useCountdown({ date: unlockedAt });

  const displayMinute = seconds > 60;
  const minutes = Math.ceil(seconds / 60);

  if (seconds === 0) {
    dispatch(setAuthStep(LOGIN_STEPS.LOGIN));
  }

  return (
    <Alert
      type="error"
      title={
        <FormattedMessage
          id="page.login.accountLocked"
          defaultMessage="Your account has been locked for security reasons. Please try again in {displayMinute, select, true {{minutes} minutes} other {{seconds} seconds}}."
          values={{ displayMinute, minutes, seconds }}
        />
      }
    />
  );
};

export default AccountLockWrapper;
